import React, { Fragment } from 'react';
import gaspolicy1 from '../../../../images/gaspolicy1.png';
import gaspolicy2 from '../../../../images/gaspolicy2.png';
import IncidentReport from '../StartYourBooking/IncidentReport';

const GasPolicy = () => (
  <Fragment>
    <p>
      It is the responsibility of the driver to always return Autzu PRO
      vehicles with a full tank of gas. The needle of the fuel gauge must
      be directly <strong>ON</strong> the full line to be considered as
      full.
    </p>

    <p>
      If the gas tank is <strong>not</strong> full, you will be asked to
      accept a gas shortage credit at the start of your booking during the
      pre-booking inspection process. You will be reimbursed based on the
      fuel gauge "<strong>Credit</strong>" image below at the end of your
      booking. The previous driver will be charged a fee based on the “
      <strong>Charge</strong>” image below.
    </p>
    <br />
    <p>Spring/Summer:</p>
    <div style={{ textAlign: 'center', width: '100%' }}>
      <img src={gaspolicy1} className="gas-policy-image" />
    </div>
    <p>Fall/Winter:</p>
    <div style={{ textAlign: 'center', width: '100%' }}>
      <img src={gaspolicy2} className="gas-policy-image" />
    </div>

    <br />
    <p>
      *Please note that Credit and Charge amounts may change seasonally
      depending on current gas prices.
    </p>
    <h4 className="subtitle">How to submit an incident report?</h4>
    <IncidentReport />
  </Fragment>
);

export default GasPolicy;



// WEBPACK FOOTER //
// ./src/components/Static/DriverFaq/DrivesharingPolicies/GasPolicy.js